<template>
  <div>
    <BaseTitle :title="$t('content.report_storage')" />
    <v-row>
      <v-progress-circular class="text-center" v-if="loadingLoad === true" indeterminate color="primary" />
      <v-col md="5">
        <v-card class="pa-6">
          <strong class="header-text">{{ $t('content.total_student') }}</strong>
          <div class="mt-6 total-student-card pa-6 d-flex justify-space-around">
            <svg-icon icon="total_student" width="200" height="200" />
            <div class="succ-content mt-5">
              <h1 class="succ-heading">{{ listData.totalStudent }}</h1>
              <div class="succ-content">{{ $t('content.student') }}</div>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col md="7">
        <v-card class="pa-6">
          <div class="d-flex justify-space-between">
            <strong class="header-text">{{ $t('content.total_class') }}</strong>
            <strong class="header-text">{{ listData.totalClass.length }} {{ $t('menu.class') }}</strong>
          </div>
          <div id="chart" class="mt-6  pa-6 d-flex justify-space-around">
            <apexchart :options="chartOption" :series="series" />
          </div>
        </v-card>
      </v-col>
      <v-col md="12">
        <v-card class="pa-6">
          <strong class="header-text">{{ $t('content.total_storage') }}</strong>
          <div class="succ-content">
            <div id="chart" class="  d-flex justify-space-around">
              <apexchart :options="chartOptionsDonut" :series="seriesDonut" />
            </div>
          </div>
          <div class="succ-content" style="margin-right : 80px">
            <strong class="header-text">{{ listData.totalStorage.storageUsed }} MB of {{ listData.totalStorage.totalStorage }} MB used</strong>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import apexchart from 'vue-apexcharts';
// import NoData from '@/components/table/NoData';

export default {
  name: 'ReportStorageTeacher',
  components: {
    apexchart,
    BaseTitle
    // NoData
  },
  computed: {
    ...mapGetters({})
  },

  data: () => ({
    loadingLoad: false,
    listData: [],
    series: [],
    seriesDonut: []
  }),
  methods: {
    getData() {
      this.loadingLoad = true;
      this.$store
        .dispatch(`Storage/fetchListStorageTeacher`)
        .then(data => {
          data.totalStorage.percentage = parseInt(data.totalStorage.percentage);
          data.totalStorage.storageUsed = parseInt(data.totalStorage.storageUsed);
          data.totalStorage.totalStorage = parseInt(data.totalStorage.totalStorage);

          const nuevo = data.totalStorage.percentages.map(i => Number(i));
          data.totalStorage.percentages = [];
          data.totalStorage.percentages = nuevo;

          const labels = data.totalClass.map(({ classroomName }) => classroomName);
          const series = data.totalClass.map(({ totalCourse }) => totalCourse);
          this.series = series;
          const chartOption = {
            chart: {
              type: 'pie'
            },
            labels: labels,
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 200
                  },
                  legend: {
                    position: 'bottom'
                  }
                }
              }
            ],
            dataLabels: {
              style: {
                fontSize: '14px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 'bold'
              },
              formatter: function(value, { seriesIndex }) {
                return 'Course  : ' + series[seriesIndex];
              }
            }
          };
          if (data.totalStorage.percentages[0] === 0) {
            data.totalStorage.percentages[0] = 1;
            data.totalStorage.storageUsed = 1;
          }
          let seriesDonut = data.totalStorage.percentages;
          this.seriesDonut = seriesDonut;
          const chartOptionsDonut = {
            chart: {
              type: 'donut'
            },
            labels: ['Teachers', 'Students'],
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: true,
                    value: {
                      fontSize: '20px',
                      fontWeight: 800,
                      show: true,
                      offsetY: 20
                    },
                    total: {
                      show: true,
                      showAlways: true,
                      label: '',
                      formatter: function() {
                        return seriesDonut[0] + seriesDonut[1] + ' MB';
                      }
                    }
                  }
                }
              }
            },
            dataLabels: {
              style: {
                fontSize: '10px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 'bold',
                colors: ['rgb(0, 143, 251)', 'rgb(0, 227, 150)']
              },
              background: {
                enabled: true,
                foreColor: '#fff',
                padding: 4,
                borderRadius: 10,
                borderWidth: 1,
                borderColor: '#fff',
                opacity: 0.9
              },
              formatter: function(value, { seriesIndex }) {
                if (seriesIndex === 0) {
                  return 'Teachers ' + seriesDonut[0] + ' MB';
                } else {
                  return 'Students ' + seriesDonut[1] + ' MB';
                }
              }
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 200
                  },
                  legend: {
                    position: 'bottom'
                  }
                }
              }
            ]
          };

          this.chartOption = chartOption;
          this.chartOptionsDonut = chartOptionsDonut;
          this.listData = data;
        })
        .finally(() => (this.loadingLoad = false));
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
.header-text {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 16px;
  line-height: 19px;
  text-align: left;
}

.total-student-card {
  background-color: #f3f3f3;
  border-radius: 8px;
  height: 180px;
}

.succ {
  &-content {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 20px;
    color: #c83492;
    font-family: Montserrat;
    font-size: 16px;
    line-height: 19px;
    text-align: left;
  }

  &-heading {
    color: #c83492;
    font-family: Montserrat;
    font-weight: bold;
    font-size: 24px;
  }
}
</style>
